/**
 * Created by zzy on 2019/8/26.
 */
import VideoPlayerModal from './VideoPlayerModal.vue'
export default VideoPlayerModal



// WEBPACK FOOTER //
// ./src/views/common/VideoPlayerModal/index.js